const MOBILE_BOTTOM_NAVIGATION = {
  MOBILE_BOTTOM_NAVIGATION_TAP: 'MOBILE_BOTTOM_NAVIGATION_TAP'
};

export {MOBILE_BOTTOM_NAVIGATION};
